import axios from 'axios';
import { API_URL } from './api.path';
import { logout } from '../redux/slices/Auth.slice';
import authHeaders from './authHeader';

const instance = axios.create({
  baseURL: API_URL,
  ...authHeaders()
});

const setUpInterceptor = (store) => {
  // request interceptor
  instance.interceptors.request.use(
    (config) => {
      const token = store.getState().auth?.token || '';
      if (token) {
        config.headers.Authorization = token;
      }
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );
  // response interceptor
  instance.interceptors.response.use(
    (res) => res,
    (error) => {
      console.log('>>>>>>>>>>>>error', error);
      if (error.response?.status === 401) {
        setTimeout(() => {
          store.dispatch(logout());
        }, 1000);
      }
      return Promise.reject(error);
    }
  );
};

export { instance };
export default setUpInterceptor;
